<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/system/businessManagement' }">用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>产品管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="company_name">{{company_name}}</div>
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="预警系统企业版" name="first">
            <div>
              <!-- <div class="role_name">
                <span>用户类型：</span>
                <el-select v-model="role_id" @change="changeRoleFn" filterable placeholder="请选择角色">
                  <el-option
                    v-for="item in roleListArr"
                    :key="item.type"
                    :label="item.name"
                    :value="item.type">
                  </el-option>
                </el-select>
              </div> -->
              <el-form
                ref="myForm"
                label-width="140px"
                :model="formData"
                :rules="formRules"
                status-icon>
                <!-- 下拉 -->
                <!-- <el-form-item label="产品状态：" prop="company_productStatus">
                  <el-select v-model="formData.company_productStatus" placeholder="请选择产品状态" style="width: 300px">
                    <el-option label="正式试用" value="ing"></el-option>
                    <el-option label="免费试用" value="free"></el-option>
                    <el-option label="停用" value="tingyong"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="到期时间："  prop="company_endTime">
                  <el-date-picker
                    v-model="formData.times"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @input="timeFn">
                  </el-date-picker>

                  <el-date-picker
                    v-if="false"
                    v-model="formData.gov_try_end_time"
                    type="date"
                    placeholder="选择日期" style="width: 300px">
                  </el-date-picker>
                </el-form-item> -->
                <!-- 单选 -->
                <el-form-item label="企业状态：" prop="type">
                    <el-radio-group v-model="nowType" @change="changeRadio">
                      <el-radio :label="2">正式使用</el-radio>
                      <el-radio :label="1">免费试用</el-radio>
                      <el-radio :label="3">停用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="试用期：" v-if="nowType == 1" prop="time">
                    <el-date-picker
                      v-model="formData.times"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="timestamp"
                      :default-time="['00:00:00','23:59:59']"
                      @input="timeFn"
                      clearable>
                    </el-date-picker>
                </el-form-item>
              </el-form>
              <div class="part_title">
                <span>权限设置</span>
              </div>
              <el-table
                :data="tableData"
                border
                :span-method='objectSpanMethod'
                style="width: 100%">
                <!-- <el-table-column
                  type="selection"
                  width="55">
                </el-table-column> -->
                <el-table-column
                  prop="rightname"
                  label="项目权限"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="page_rightname"
                  label="页面权限"
                  width="180">
                </el-table-column>
                <el-table-column
                  label="操作权限">
                  <template slot-scope="scope">
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox @change="checkboxFn(scope.row)" v-for="(item) in scope.row.operate" :disabled="item.edtion_right || nowType==3 ? true:false" :key="item.code" :label="item.code">{{item.operate_rightname}}</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="预警系统政府版" name="second">
            <div>
              <el-form
                ref="myForm"
                label-width="140px"
                :model="formData"
                :rules="formRules"
                status-icon>
                <!-- 单选 -->
                <el-form-item label="企业状态：" prop="type">
                    <el-radio-group v-model="gov_type" @change="gov_changeRadio">
                      <el-radio :label="2">正式使用</el-radio>
                      <el-radio :label="1">免费试用</el-radio>
                      <el-radio :label="3">停用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="试用期：" v-if="gov_type == 1" prop="time">
                    <el-date-picker
                      v-model="formData.gov_times"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="timestamp"
                      :default-time="['00:00:00','23:59:59']"
                      @input="timeFn"
                      clearable>
                    </el-date-picker>
                </el-form-item>
              </el-form>
              <div class="part_title">
                <span>权限设置</span>
              </div>
              <el-table
                :data="gov_tableData"
                border
                :span-method='objectSpanMethod'
                style="width: 100%">
                <!-- <el-table-column
                  type="selection"
                  width="55">
                </el-table-column> -->
                <el-table-column
                  prop="rightname"
                  label="项目权限"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="page_rightname"
                  label="页面权限"
                  width="180">
                </el-table-column>
                <el-table-column
                  label="操作权限">
                  <template slot-scope="scope">
                    <el-checkbox-group v-model="gov_checkList">
                      <el-checkbox @change="checkboxFn(scope.row)" v-for="(item) in scope.row.operate" :disabled="item.edtion_right || gov_type==3 ? true:false" :key="item.code" :label="item.code">{{item.operate_rightname}}</el-checkbox>
                    </el-checkbox-group>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="APP" name="third">APP</el-tab-pane>
        </el-tabs>
        <el-button style="margin-top: 10px" type="primary" @click="submitFn">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import commApi from "../../api/commonApi"
import {timestampToTime} from "@/mixins/tools.js"

export default {
  mixins: [timestampToTime],
  data() {
    return {
      activeName: 'first',
      // 企业版权限list
      checkList: [],
      // 政府版权限list
      gov_checkList: [],
      disableList: [],
      // 企业
      tableData: [],
      // 政府
      gov_tableData: [],
      // 用户类型（0企业，1政府）
      company_type: '',
      // 企业
      nowType: '',
      // 政府
      gov_type: '',
      roleListArr: [
        {type: 1, name: '试用'},
        {type: 2, name: '正式用户'},
      ],
      role_id: Number(this.$route.query.id),
      formData: {
        // company_productStatus: '',  // 企业名字
        times: [],
        gov_times: []
      },
      formRules: {
        type: [{
          required: true,
          message: "产品状态不能为空",
          trigger: "blur"
        }],
        time: [{
          // required: true,
          message: "时间不能为空",
          trigger: "blur"
        }]
      },
      gov_try_start_time: '',
      gov_try_end_time: '',
      try_start_time: '',
      try_end_time: '',
      company_name: '',
    }
  },
  created() {
    this.adminInfo()
    // 给times一个默认值，避免未选择时间时报错
    
  },
  methods: {
    changeRadio(value){
      this.roleListFn()
      console.log(value);
    },
    gov_changeRadio(value){
      this.gov_roleListFn()
    },
    changeRoleFn() {
      this.adminInfo(this.role_id)
    },
    checkboxFn(rows) {
      if(this.activeName == 'first'){
        console.log(this.checkList)
      }else if(this.activeName == 'second'){
        console.log(this.gov_checkList);
      }
      
    },
    // 将起始时间转换为时间戳
    beforeValidate() {
      // 如果有时间
      // console.log(this.formData.times);
      if(this.gov_type == 1) {
        if(this.company_type == 1){
          // this.formData.gov_try_start_time = this.$commFunc.parseToTimestamp(
          //   this.formData.times[0]
          // );
          // this.formData.gov_try_end_time = this.$commFunc.parseToTimestamp(
          //   this.formData.times[1]
          // );
          this.formData.gov_try_start_time = this.formData.times[0]
          this.formData.gov_try_end_time = this.formData.times[1]
          console.log(`starttime${this.formData.gov_try_start_time}`);
          console.log(`endtime${this.formData.gov_try_end_time}`);
        }else{
          this.formData.try_start_time = this.$commFunc.parseToTimestamp(
            this.formData.times[0]
          );
          this.formData.try_end_time = this.$commFunc.parseToTimestamp(
            this.formData.times[1]
          );
        }
        
        // console.log(this.formData);
      }else{}
     
    },
    // 时间
    timeFn(e) {
      this.$nextTick(() => {
        this.formData.times = [];
        this.formData.gov_times = [];
        this.$set(this.formData, "gov_times", [e[0], e[1]]);
      });
      if(this.company_type == 1){
        this.formData.gov_try_start_time = this.formData.gov_times[0]/1000
        this.formData.gov_try_end_time = this.formData.gov_times[1]/1000
      }else{
        this.formData.try_start_time = this.formData.times[0]/1000
        this.formData.try_end_time = this.formData.times[1]/1000
      }
      console.log(this.formData);
    },
    // 企业 提交
    submitFn() {
      // this.beforeValidate()
      let datas = {}
      // 政府
      console.log(this.company_type);
      if(this.company_type == 1){
        // console.log(`11111111111111100${this.gov_type}`);
        datas = {
          company_type: this.company_type,
          gov_type: this.gov_type,
          id: this.role_id,
          // gov_try_start_time: ,
          ...this.formData
        }
      }else{
        datas = {
          company_type: this.company_type,
          ...this.formData,
          type: this.nowType,
          id: this.role_id,
        }
      }
      if(this.activeName == 'first'){
        datas.right_code = this.checkList.join(',')
      }else  if(this.activeName == 'second'){
        datas.gov_right_code = this.gov_checkList.join(',')
      }
      // console.log(`后权限：${datas.right_code}`);
      console.log(datas);
      api.editCompany(datas)
        .then(res => {
          if(res.error_code == 0) {
            this.$message.success("提交成功！！");
            this.$router.push({
              name: "businessManagement"
            });
          }
        })
        .catch(err => {
          this.$message.success(err)
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const span = column['property'] + '-span'
      if(row[span]){
        return row[span]
      }
    },

    // 企业---角色初始化
    roleListFn() {
      let datas = {
        type: this.nowType
      }
      // 企业---权限设置list
      api.rightcodeList(datas)
      .then(res => {
        // 权限设置 
        this.tableData = res.list
        this.tableData = mergeTableRow(this.tableData, ['rightname'])
        // this.adminInfo()
      })
      .catch(err => {
        this.$message(err);
      });
    },
    // 政府---角色初始化
    gov_roleListFn() {
      let datas = {
        gov_type: this.gov_type
      }
      api.rightcodeListG(datas)
      .then(res => {
        this.gov_tableData = res.list
        this.gov_tableData = mergeTableRow(this.gov_tableData, ['rightname'])
      })
      .catch(err => {
        this.$message(err);
      });
    },
    // 编辑详情
    async adminInfo() {
      let datas = {
        id: this.role_id
      }
      // 当前企业详细信息
      api.adminCompanyInfo(datas)
      .then(res => {
        console.log(`前权限：${res.info.right_code}`);
        this.company_name = res.info.company_name
        this.company_type = res.info.company_type
        // 企业用户状态
        this.nowType = res.info.type
        // 政府用户状态
        this.gov_type = res.info.gov_type
        console.log(`22222222222222200${this.gov_type}`);
        // time
        this.gov_try_start_time = res.info.gov_try_start_time
        this.gov_try_end_time = res.info.gov_try_end_time
        this.try_start_time = res.info.try_start_time
        this.try_end_time = res.info.try_end_time
        // push进times数组 gov_times--政府版时间，times--企业版时间
        this.formData.gov_times.push(this.gov_try_start_time*1000,this.gov_try_end_time*1000)
        this.formData.times.push(this.try_start_time*1000,this.try_end_time*1000)
        // 如果后台数据无时间值，则设置默认时间为当前时间
        if(this.formData.times[0] == 0 && this.formData.times[1] == 0){
          this.formData.times = []
          let start_time = new  Date().getTime()
          this.formData.times.push(start_time,start_time+24*60*60*1000)
        }
        if(this.formData.gov_times[0] == 0 && this.formData.gov_times[1] == 0){
          this.formData.gov_times = []
          let start_time = new  Date().getTime()
          this.formData.gov_times.push(start_time,start_time+24*60*60*1000)
        }
        // 权限list
        this.checkList = res.info.right_code.split(",").map(Number)
        this.gov_checkList = res.info.gov_right_code.split(",").map(Number)
        this.gov_roleListFn()
        this.roleListFn()
      })
      .catch(err => {
        this.$message(err);
      });
    },

    // 取消
    cancelFn() {
      this.$confirm('取消页面将不会保存，是否确定？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({
          name: "earlyWarning"
        });
      }).catch( err => {
        this.$message(err);
      });
    }
  }
};

export function mergeTableRow(data, merge) {
  if (!merge || merge.length === 0) {
    return data
  }
  merge.forEach((m) => {
    const mList = {}
    data = data.map((v, index) => {
      const rowVal = v[m]
      if (mList[rowVal] && mList[rowVal].newIndex === index) {
        mList[rowVal]['num']++
        mList[rowVal]['newIndex']++
        data[mList[rowVal]['index']][m + '-span'].rowspan++
        v[m + '-span'] = {
          rowspan: 0,
          colspan: 0
        }
      } else {
        mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
        v[m + '-span'] = {
          rowspan: 1,
          colspan: 1
        }
      }
      return v
    })
  })
  return data
}
</script>

<style lang="scss" scoped>
.company_name{
  font-size: 20px;
  margin-bottom: 20px;
}
.zv-breadcrumb-wrap{
  margin-bottom: 20px;
}
.part_title{
  font-size: 20px;
  margin-bottom: 10px;
  span{
    border-bottom: 1px solid rgb(109, 186, 221);
  }
}
.line {
  text-align: center;
  color: #8b8b8b;
}
.role_name {
  .el-input {
    width: 220px;
  }
  margin-bottom: 30px;
}
.data_font {
  span {
    font-weight: bold;
    margin-left: 20px;  
    margin-right: 10px;  
  }
}
</style>